let hubMgt = [{
		path: 'hubMgt',
		meta: {
			title: '网点管理',
			breadcrumb: true
		},
		component: {
			name: 'hubMgt',
			template: '<router-view></router-view>'
		},
		children: [{
				path: '/',
				meta: {
					title: '网点管理',
				},
				component: (resolve) => require(['@/views/plat/hubManagement/hubMgt'], resolve)
			},
			{
				path: 'newAdd',
				meta: {
					title: "新增",
					breadcrumb: true,
				},
				component: (resolve) => require(['@/views/plat/hubManagement/hubMgt/children/newAdd'], resolve)
			},
			{
				path: 'editor',
				meta: {
					title: "编辑",
					breadcrumb: true,
				},
				component: (resolve) => require(['@/views/plat/hubManagement/hubMgt/children/editor'], resolve)
			},
			{
				path: 'refWecomDepartment',
				meta: {
					title: "关联企业微信",
					breadcrumb: true,
				},
				component: (resolve) => require([
					'@/views/plat/hubManagement/hubMgt/children/refWecomDepartment'], resolve)
			},
			{
				path: 'nutritionButlerList',
				meta: {
					title: "光明使者",
					breadcrumb: true,
				},
				component: (resolve) => require([
					'@/views/plat/hubManagement/hubMgt/children/nutritionButlerList'
				], resolve)
			},
			{
				path: 'accountRecords',
				meta: {
					title: "账户记录",
					breadcrumb: true,
				},
				component: (resolve) => require(['@/views/plat/hubManagement/hubMgt/children/accountRecords'],
					resolve)
			},
			{
				path: 'device',
				meta: {
					title: "智能理疗设备",
					breadcrumb: true,
				},
				component: (resolve) => require(['@/views/plat/hubManagement/hubMgt/children/device'], resolve)
			}
		]
	},
	{
		path: 'device',
		meta: {
			title: '智能理疗设备',
			breadcrumb: true
		},
		component: {
			name: 'device',
			template: '<router-view></router-view>'
		},
		children: [{
				path: '/',
				meta: {
					title: '智能理疗设备',
				},
				component: (resolve) => require(['@/views/plat/hubManagement/device'], resolve)
			},
			{
				path: 'newAdd',
				meta: {
					title: "新增",
					breadcrumb: true,
				},
				component: (resolve) => require(['@/views/plat/hubManagement/device/children/newAdd'], resolve)
			},
			{
				path: 'editor',
				meta: {
					title: "编辑",
					breadcrumb: true,
				},
				component: (resolve) => require(['@/views/plat/hubManagement/device/children/editor'], resolve)
			}
		]
	},
]

export default {
	path: '/hubManagement',
	redirect: '/hubManagement/hubMgt',
	meta: {
		title: "网点管理",
		breadcrumb: true
	},
	component: {
		name: 'hubManagement',
		template: '<router-view></router-view>'
	},
	children: hubMgt
}


// WEBPACK FOOTER //
// ./src/router/hubManagement.js